const Hero = () => {
  return (
    <div className="hero-home-container">

    </div>
  )
}

export default Hero